import {
  IS_LOADING,
  NET_HOLDING_BROKER_NUMBER,
  NET_HOLDING_CHART_DATA,
  NET_HOLDING_EXCLUDE_MF,
  NET_HOLDING_RELOADED_TIME,
  NET_HOLDING_TOOLTIP_DATA,
  NET_HOLDINGS_RESULT_BY,
  NET_HOLDINGS_SET_SECTOR,
} from '../../redux/NetHoldings/ActionTypes';
import { message } from 'antd';
import axiosOrder from '../../axios';

const reducer = (state = {
  viewBy: 1,
  tableData: [],
  tooltipData: [],
  sector: 'All',
  brokerNumber: 1,
  loading: false,
  reloadedTime: '',
  excludeMf: false,
},
action: { type: string; data: string; }) => {
  switch (action.type) {
  case NET_HOLDING_BROKER_NUMBER:
    return {
      ...state,
      brokerNumber: action.data,
    }
  case NET_HOLDING_RELOADED_TIME:
    return {
      ...state,
      reloadedTime: action.data,
    }

  case NET_HOLDINGS_RESULT_BY:
    return {
      ...state,
      loading: false,
      viewBy: action.data,
    }
  case NET_HOLDING_CHART_DATA:
    return {
      ...state,
      tableData: action.data,
    }
  case NET_HOLDING_EXCLUDE_MF:
    return {
      ...state,
      excludeMf: action.data,
    }
  case NET_HOLDINGS_SET_SECTOR:
    return {
      ...state,
      loading: false,
      sector: action.data,
    }
  case NET_HOLDING_TOOLTIP_DATA:
    return {
      ...state,
      tooltipData: action.data,
    }
  case IS_LOADING:
    return {
      ...state,
      loading: action.data,
    }
  default:
    return state;
  }
}

const Loading = (loading: boolean) => ({ type: IS_LOADING, data: loading });
const setNetHoldingsData = (response: any) => ({ type: NET_HOLDING_CHART_DATA, data: response });
const setNetReloadedTime = (data: string) => ({ type: NET_HOLDING_RELOADED_TIME, data });
const setNetHoldingToolTipData = (data: any) => ({ type: NET_HOLDING_TOOLTIP_DATA, data });

export const loadNetHolding = (sector: string,
  date: number, broker: number, excludeMf: boolean) => async (dispatch: (data: any) => void) => {
  try {
    dispatch(Loading(true));
    const { data: { data, reloadedTime } } = await axiosOrder.get('/systemx/dalalstreet/getBrokerFavorites', {
      params: {
        broker,
        type: 'buyTotalQuantity',
        date,
        sector,
        dataType: 'chart',
        excludeMf,
      },
    });
    dispatch(setNetHoldingToolTipData(data[0].toolTipData));
    dispatch(setNetReloadedTime(reloadedTime));
    dispatch(setNetHoldingsData(data));
    dispatch(Loading(false));
  } catch (ex) {
    message.error('Cannot load net holdings. Try again');
    dispatch(setNetHoldingsData([]));
    dispatch(Loading(false));
  }
}
export default reducer;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/NetHoldings/Actions.ts